export const environment = {
    production: false,
    // Settings for TEST server
    baseUrlAPI: 'https://myenergytest.novitech.sk/api/v1',
    baseUrlDataAPI: 'https://myenergytest.novitech.sk/data',    
};
